import { until } from "@vueuse/core";
import { computed, watch } from "vue";
import { type ProcessInTree } from "@/stores/processes-store";
import { BaseLinkedEntitiesManager } from "../mystekz-linked-entities/manager";
import { ProcessEntity } from ".";
import { useWorktreeManager } from "@/composables/worktree-manager";

/**
 * Manages the business entities and replaces
 */
export class ProcessesManager extends BaseLinkedEntitiesManager<ProcessEntity> {
    nodeType = "process" as const;
    worktreeManager = useWorktreeManager();

    constructor(baseUrl: string) {
        super(baseUrl);
        const isLoading = computed(() => {
            return (
                this.worktreeManager.isFetching.value ||
                this.organizationManager.isLoadingOrganizations.value ||
                this.stekManager.isLoadingSteks.value
            );
        });
        this.ready = until(isLoading).not.toBeTruthy();

        watch(
            this.worktreeManager.worktree,
            async (newWorktree) => {
                if (newWorktree) {
                    const processes: ProcessInTree[] = [];
                    for (const d of newWorktree.domains) {
                        for (const p of d.products) {
                            for (const pr of p.processes) {
                                processes.push(pr);
                            }
                        }
                    }
                    this.setEntities(processes);
                }
            },
            { immediate: true }
        );
    }
}
